<template>
    <div ref="editor" class="w-full h-48 block mt-2"></div>
</template>
<script setup>
import { ref, watch, nextTick, onMounted, defineProps, defineEmits } from 'vue';
import * as monaco from "monaco-editor";

const emits = defineEmits(['update:modelValue']);

const props = defineProps({
    modelValue: {
        type: String,
        default: null
    },
    options: {
        type: Object,
        default: () => {}
    }
});

const editor = ref(null);
var editorInstance = null;

onMounted(() => {
    const options = {
        value: props.modelValue ?? `const main = () => { console.log('Your code Here') }`,
        language: 'javascript',
        theme: 'vs-dark',
        ...props.options
    };

    editorInstance = monaco.editor.create(editor.value, { 
        ...options,
    });

    editorInstance?.onDidChangeModelContent(() => {
        emits('update:modelValue', editorInstance.getValue())
    }); 
});

watch(() => props.modelValue, () => {
    nextTick(() => {
        if(props.modelValue !== editorInstance.getValue()){
            editorInstance.setValue(props.modelValue);
        }
    })
})
</script>